import React, { FunctionComponent, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Item, Result } from '../helper/models/homepage'
import { singleRestaurantMobX } from '../global'
import { ImageProcess } from '../helper/services/imageProcess'
const imp = new ImageProcess()
const GroupRestaurants = () => {
  const [result, setResult] = useState<Result[]>([])

  useEffect(() => {
    const api = async () => {
      const data = await fetch(
        'https://api.munchies.com.bd/parse/functions/homepage/',
        {
          method: 'POST',
          headers: {
            'X-Parse-Application-Id': 'food',
          },
        }
      )
      const jsonData = await data.json()

      setResult(jsonData.result)
    }
    api()
  }, [])
  return (
    <div className="px-16 text-white bg-black">
      <div className=" text-cyan-500">
        {result &&
          result.map((e) => <RestaurantLists key={e.id} restaurantList={e} />)}
      </div>
    </div>
  )
}

export default GroupRestaurants

const RestaurantLists: FunctionComponent<{ restaurantList: Result }> = (
  restaurantList
) => {
  return (
    <div className="mb-4">
      <h6 className="text-2xl">{restaurantList.restaurantList.name}</h6>
      <div className="flex-wrap grid-flow-col">
        {restaurantList.restaurantList.items.map((res) => (
          <Link to={`/restaurant/${res.id}`} key={res.id}>
            <div
              className="inline-grid pr-4 my-4 overflow-hidden"
              style={{ width: '25%', height: '200px' }}
              onClick={(e) => save(res)}
              key={res.id}
            >
              <img
                src={imp.process(res.banner_image)}
                alt={res.id}
                style={{ height: '150px', width: '90%' }}
              ></img>
              <p style={{ width: '90%' }} className="text-white text-ellipsis">
                {res.name}
              </p>
              <p className="text-ellipsis" style={{ width: '90%' }}>
                {res.cuisines}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}
function save(item: Item): React.MouseEventHandler<HTMLDivElement> | undefined {
  singleRestaurantMobX.assign(item)
  return
}
